import React from "react";

const NumberList = ({ items, item_name }) => {
  const renderItems = () => {
    if (Array.isArray(items)) {
      return items.map((item, index) => (
        <li key={index}>
          {item_name && (
            <span className="bold">
              {item_name} #{index + 1}:
            </span>
          )}{" "}
          {item}
        </li>
      ));
    }
  };

  return (
    <div className="container-fluid" data-aos="fade-up">
      <div className="position-relative">
        <ol>{renderItems()}</ol>
      </div>
    </div>
  );
};

export default NumberList;
